import { render, staticRenderFns } from "./mechanicalarm.vue?vue&type=template&id=270727d8"
import script from "./mechanicalarm.vue?vue&type=script&lang=js"
export * from "./mechanicalarm.vue?vue&type=script&lang=js"
import style0 from "./mechanicalarm.vue?vue&type=style&index=0&id=270727d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports